
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class LogsService {
    
    static getAllLocation(CompanyCode, email) {
        //var data = [];
        return axios.get(`${BaseUrl}CompanyLocation?CompanyCode=${CompanyCode ? CompanyCode : "" }&email=${email}`);
    }

}


// WEBPACK FOOTER //
// ./src/Services/CompanyLocationService/CompanyLocationService.js